export const REDRAW_PERIOD_MS = 3000;
export const MAX_FOLLOWERS_PER_CLIENT = 20;
